import React, { Component } from 'react';
import { Button, Input, InputNumber, Modal, Radio, Upload, message } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import '../css/style.less';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import GPCalculateModal from './GPCalculateModal';

const RadioGroup = Radio.Group;
const { TextArea } = Input;
const keepTwoDecimals = value => Number(value.toFixed(2))

class FloorPriceModal extends Component {
    state = {
        visible: false,
        loading: false,
        params: {},
        customerParams: {},
        KeyAnalysisData: {},
        annualOutputData: [],
        nonBindAnnualOutputData: [],
        priceParams: {},
        rate: 0,
        type: '',
        fileList: [],
        serveFeeType: '',
        parameterValue: null,
        evaluateCalcGpId: null,
        universalParams: {},
    }

    show = (record, type, basePriceStatus, basePrice) => {
        const { evaluateRecordId } = record;
        this.setState({
            visible: true,
            record,
            type,
        }, () => {
            this.loadData(evaluateRecordId, basePriceStatus);
            this.loadKeyAnalysisData(evaluateRecordId, basePriceStatus);
            this.queryEvaluateRecordTaxRate();
            if(type == 'floorPrice'){
                this.setState({
                    priceParams: basePrice ? {
                        ...basePrice, 
                    } : {}
                },() => {
                    this.queryServeFeeType(evaluateRecordId);
                    this.queryParameter(evaluateRecordId);
                })
            }else{
                this.queryEvaluateRecordBasePrice(evaluateRecordId);
            }
            if (basePriceStatus === 'VISIT') {
                this.loadCustomerParams(evaluateRecordId);
            }
        });
    };
    // 获取 GP% 默认值
    queryParameter = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryParameter,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.parameter) {
                    const parameterValue = res.parameter.parameterValue;
                    let newParameterValue = this.state.priceParams.gpCalcuationValue || parameterValue
                    this.handleChange(newParameterValue, 'gpCalcuationValue');
                    this.setState({
                        parameterValue
                    })
                }
            }
        };
        $.sendRequest(options);
    }

    //获取项目基本信息数据
    loadData = (evaluateRecordId, basePriceStatus) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                        evaluateRecordCalculate,
                        evaluateRecordCalculate: { targetNames, smoPredicatedAverageInGroupRate },
                    }
                } = res;
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCalculate,
                            ...evaluateRecordCustomer,
                            targetNames: basePriceStatus === 'VISIT' ? targetNames : '',
                            smoPredicatedAverageInGroupRate: basePriceStatus === 'VISIT' ? smoPredicatedAverageInGroupRate : '',
                        },
                    }
                );
            },
        }
        $.sendRequest(options);
    }

    //获取重难点分析数据
    loadKeyAnalysisData = (evaluateRecordId, basePriceStatus) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordDifficulty,
            data: {
                evaluateRecordId,
                quotationType: basePriceStatus === 'VISIT' ? 'VISIT_QUOTATION' : 'FTE_QUOTATION',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    KeyAnalysisData: (res.data || {}),
                });
                
            }
        };
        $.sendRequest(options);
    };

    
    isWorthObj = (obj) => {
        // 先验证输入是否为对象（排除null/数组等）
        if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
            return false;
        }
        return Object.keys(obj).length !== 0;
    }

    //获取客户参数数据
    loadCustomerParams = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordCalculate,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { evaluateRecordCalculate = {}, evaluateRecordCalculateExternal } = res
                const { treatGroupList = [] } = evaluateRecordCalculate;
                const newTreatGroupList = [];
                treatGroupList.map((el, index) => {
                    const { cycleShow, hospitalMedicationFrequencyShow, routeList, customFrequency, treatmentPeriodFrequencyShow } = el;
                    el.groupName = `治疗组别${index + 1}`
                    el.groupIndex = index;
                    el.cycleRangeShow = customFrequency ? customFrequency : ((cycleShow && hospitalMedicationFrequencyShow) ? `${cycleShow}(${hospitalMedicationFrequencyShow})` : '');
                    const len = (routeList || []).length;
                    if (len) {
                        routeList.forEach((route, routeIndex) => {
                            const { 
                                evaluateHospitalMedicationFrequencyOptimize = {},
                            } = route;
                            if (this.isWorthObj(evaluateHospitalMedicationFrequencyOptimize)) {
                                newTreatGroupList.push({
                                    ...el,
                                    ...route,
                                    ...evaluateHospitalMedicationFrequencyOptimize,
                                    rowSpan: routeIndex === 0 ? len : 0,
                                    rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                                })
                            } else {
                                newTreatGroupList.push({
                                    ...el,
                                    ...route,
                                    visitCycleShow: cycleShow,
                                    medicationCycleShow: hospitalMedicationFrequencyShow,
                                    medicationShow: treatmentPeriodFrequencyShow,
                                    rowSpan: routeIndex === 0 ? len : 0,
                                    rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                                })
                            }
                        });
                    } else {
                        newTreatGroupList.push({
                            ...el,
                            rowSpan: 1,
                            rowId: el.evaluateRecordCalculateTreatGroupId
                        });
                    }

                })
                this.setState({
                    customerParams: {
                        evaluateRecordId,
                        ...evaluateRecordCalculate,
                        treatGroupList: newTreatGroupList,
                        ...evaluateRecordCalculateExternal,
                    }
                })
            }
        };
        $.sendRequest(options);
    }

    //获取年产出表格数据
    loadEvaluateVisitFeeData = (evaluateRecordId, serveFeeType) => {
        const { priceParams: { basePriceStatus, quotationApprovalStatus }, type } = this.state;
        const url = basePriceStatus === 'VISIT' ? API_URL.evaluate.queryEvaluateVisitFeeData : API_URL.evaluate.queryEvaluateFteDataTables;
        const options = {
            method: "POST",
            url,
            data: { evaluateRecordId, serveFeeType },
            dataType: "json",
            doneResult: (res) => {
                const { 
                    evaluateVisitQuotation = {},
                    evaluateVisitNonBindQuotation = {},
                    quotation = {},
                    nonBindQuotation = {},
                } = res;
                
                let queryAnnualOutputData = {};
                let queryNonBindAnnualOutputData = {};
                if (basePriceStatus === 'VISIT') {
                    switch (serveFeeType) {
                        case 'BIND':
                            queryAnnualOutputData = evaluateVisitQuotation;
                            break;
                        case 'NON_BIND':
                            queryNonBindAnnualOutputData = evaluateVisitNonBindQuotation;
                            break;
                        case 'NON_BIND,BIND':
                            queryAnnualOutputData = evaluateVisitQuotation;
                            queryNonBindAnnualOutputData = evaluateVisitNonBindQuotation;
                            break;
                    }
                } else {
                    switch (serveFeeType) {
                        case 'BIND':
                            queryAnnualOutputData = quotation;
                            break;
                        case 'NON_BIND':
                            queryNonBindAnnualOutputData = nonBindQuotation;
                            break;
                        case 'NON_BIND,BIND':
                            queryAnnualOutputData = quotation;
                            queryNonBindAnnualOutputData = nonBindQuotation;
                            break;
                    }
                }
                this.setState({
                    annualOutputData: queryAnnualOutputData ? [
                        {
                            ...queryAnnualOutputData
                        },
                    ] : [],
                    nonBindAnnualOutputData: queryNonBindAnnualOutputData ? [
                        {
                            ...queryNonBindAnnualOutputData
                        },
                    ] : [],
                })
                if(type == 'floorPrice'){
                    let newAnnualOutputData = queryAnnualOutputData ? [
                            {
                                ...queryAnnualOutputData
                            },
                        ] : [];
                    let newNonBindAnnualOutputData = queryNonBindAnnualOutputData ? [
                            {
                                ...queryNonBindAnnualOutputData
                            },
                        ] : []
                    let newSuggestEvaluateUnitPrice = this.state.priceParams.suggestEvaluateUnitPrice || ((newAnnualOutputData.length > 0 && newAnnualOutputData[0].evaluateUnitPrice) ? newAnnualOutputData[0].evaluateUnitPrice : undefined);
                    let newNonBindSuggestEvaluateUnitPrice = this.state.priceParams.nonBindSuggestEvaluateUnitPrice || ((newNonBindAnnualOutputData.length > 0 && newNonBindAnnualOutputData[0].evaluateUnitPrice) ? newNonBindAnnualOutputData[0].evaluateUnitPrice : undefined);
                    const isBind = serveFeeType === "BIND";  //项目包含盲态服务
                    const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
                    const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
                    if (isBind) {
                        this.handleChange(newSuggestEvaluateUnitPrice, 'suggestEvaluateUnitPrice');
                    }
                    if (isNonBind) {
                        this.handleChange(newNonBindSuggestEvaluateUnitPrice, 'nonBindSuggestEvaluateUnitPrice');
                    }
                    if (isBindAndNonBind) {
                        this.handleChange(newSuggestEvaluateUnitPrice, 'suggestEvaluateUnitPrice');
                        this.handleChange(newNonBindSuggestEvaluateUnitPrice, 'nonBindSuggestEvaluateUnitPrice');
                    }
                }
            },
        };
        $.sendRequest(options);
    };

    //获取税率
    queryEvaluateRecordTaxRate = () => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateRecordTaxRate,
            data: {},
            dataType: "json",
            doneResult: (res) => {
                const { taxRate } = res;
                this.setState({
                    rate: taxRate
                })
            },
        };
        $.sendRequest(options);
    }

    queryServeFeeType = (evaluateRecordId) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                },() => {
                    this.loadEvaluateVisitFeeData(evaluateRecordId, serveFeeType);
                })
            },
        };
        $.sendRequest(options);
    }

    //获取建议底价数据
    queryEvaluateRecordBasePrice = (evaluateRecordId) => {
        const { type } = this.state;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateRecordBasePrice,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { basePrice = {} } = res;
                // const { whetherPushGpCalcuationValue } = basePrice;
                this.setState({
                    priceParams: basePrice ? {
                        ...basePrice, 
                        // whetherPushGpCalcuationValue: whetherPushGpCalcuationValue ? whetherPushGpCalcuationValue : '0',
                    } : {}
                },() => {
                    this.queryServeFeeType(evaluateRecordId);
                    if(type == 'floorPrice') this.queryParameter(evaluateRecordId);
                })
            },
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { 
            params, 
            priceParams, 
            rate, 
            annualOutputData, 
            nonBindAnnualOutputData, 
            serveFeeType,
        } = this.state;
        const { 
            randomCaseNum,  //随机病例数
            researchCycle,  // 研究周期（估计时间）
            startSiteNum,   // 启动中心数
            lineOfBusinessString,  //业务线
            joinGroupPeriod,  //入组期
            treatmentPeriod,   //治疗期
            followUpPeriod,   //随访期
            survivalFollowUpPeriod,  //生存随访期
            dbl,  //DBL
            closeSite,  //关中心
        } = params;
        switch (key) {
            case 'gpCalcuationValue':
                priceParams[key] = value;
                // priceParams.whetherPushGpCalcuationValue = undefined;
                break;
            case 'suggestEvaluateUnitPrice':
                priceParams[key] = value ? value : 0;
                priceParams.suggestEvaluateTotalPrice = keepTwoDecimals(priceParams[key] * randomCaseNum); //建议总价金额(不含税)/人民币
                priceParams.suggestEvaluateUnitTaxPrice = keepTwoDecimals(priceParams[key] * (1 + rate * 0.01)); //建议单例价格金额(含税)/人民币
                priceParams.suggestEvaluateTotalTaxPrice = keepTwoDecimals(priceParams.suggestEvaluateUnitTaxPrice * randomCaseNum); //建议总价金额(含税)/人民币
                if (followUpPeriod <= 24) {
                    priceParams.suggestInvestigationYearOutPut = keepTwoDecimals(priceParams.suggestEvaluateTotalPrice / ((joinGroupPeriod + treatmentPeriod + followUpPeriod) / 12) / startSiteNum); //建议项目年产出(不含税)/人民币

                    priceParams.suggestInvestigationYearOutPutTax = keepTwoDecimals(priceParams.suggestEvaluateTotalTaxPrice / ((joinGroupPeriod + treatmentPeriod + followUpPeriod) / 12) / startSiteNum); //建议项目年产出(含税)/人民币

                } else {
                    priceParams.suggestInvestigationYearOutPut = keepTwoDecimals(priceParams.suggestEvaluateTotalPrice / ((joinGroupPeriod + treatmentPeriod) / 12) / startSiteNum); //建议项目年产出(不含税)/人民币

                    priceParams.suggestInvestigationYearOutPutTax = keepTwoDecimals(priceParams.suggestEvaluateTotalTaxPrice / ((joinGroupPeriod + treatmentPeriod) / 12) / startSiteNum); //建议项目年产出(含税)/人民币

                }

                
                if (annualOutputData[0]) {
                    annualOutputData[0].evaluateTotalPrice = priceParams.suggestEvaluateTotalPrice;
                    annualOutputData[0].evaluateUnitPrice = priceParams.suggestEvaluateUnitPrice;
                    annualOutputData[0].investigationYearOutput = priceParams.suggestInvestigationYearOutPut;

                    //含税金额
                    annualOutputData[0].evaluateTotalPriceTax = priceParams.suggestEvaluateTotalTaxPrice;
                    annualOutputData[0].evaluateUnitPriceTax = priceParams.suggestEvaluateUnitTaxPrice;
                    annualOutputData[0].investigationYearOutputTax = priceParams.suggestInvestigationYearOutPutTax;
                }
                break;


            case 'nonBindSuggestEvaluateUnitPrice':

                priceParams[key] = value ? value : 0;
                priceParams.nonBindSuggestEvaluateTotalPrice = keepTwoDecimals(priceParams[key] * randomCaseNum); //非盲建议总价金额(不含税)/人民币
                priceParams.nonBindSuggestEvaluateUnitTaxPrice = keepTwoDecimals(priceParams[key] * (1 + rate * 0.01)); //非盲建议单例价格金额(含税)/人民币
                priceParams.nonBindSuggestEvaluateTotalTaxPrice = keepTwoDecimals(priceParams.nonBindSuggestEvaluateUnitTaxPrice * randomCaseNum); //非盲建议总价金额(含税)/人民币
                
                priceParams.nonBindSuggestInvestigationYearOutPut = keepTwoDecimals(priceParams.nonBindSuggestEvaluateTotalPrice / ((joinGroupPeriod + treatmentPeriod) / 12) / startSiteNum); //非盲建议项目年产出(不含税)/人民币

                priceParams.nonBindSuggestInvestigationYearOutPutTax = keepTwoDecimals(priceParams.nonBindSuggestEvaluateTotalTaxPrice / ((joinGroupPeriod + treatmentPeriod) / 12) / startSiteNum); //非盲建议项目年产出(含税)/人民币

                // if (serveFeeType === "NON_BIND,BIND") {
                    if (nonBindAnnualOutputData[0]) {
                        nonBindAnnualOutputData[0].evaluateTotalPrice = priceParams.nonBindSuggestEvaluateTotalPrice;
                        nonBindAnnualOutputData[0].evaluateUnitPrice = priceParams.nonBindSuggestEvaluateUnitPrice;
                        nonBindAnnualOutputData[0].investigationYearOutput = priceParams.nonBindSuggestInvestigationYearOutPut;

                        //含税金额
                        nonBindAnnualOutputData[0].evaluateTotalPriceTax = priceParams.nonBindSuggestEvaluateTotalTaxPrice;
                        nonBindAnnualOutputData[0].evaluateUnitPriceTax = priceParams.nonBindSuggestEvaluateUnitTaxPrice;
                        nonBindAnnualOutputData[0].investigationYearOutputTax = priceParams.nonBindSuggestInvestigationYearOutPutTax;
                    }
                // } else {

                //     if (annualOutputData[0]) {
                //         annualOutputData[0].evaluateTotalPrice = priceParams.nonBindSuggestEvaluateTotalPrice;
                //         annualOutputData[0].evaluateUnitPrice = priceParams.nonBindSuggestEvaluateUnitPrice;
                //         annualOutputData[0].investigationYearOutput = priceParams.nonBindSuggestInvestigationYearOutPut;

                //         //含税金额
                //         annualOutputData[0].evaluateTotalPriceTax = priceParams.nonBindSuggestEvaluateTotalTaxPrice;
                //         annualOutputData[0].evaluateUnitPriceTax = priceParams.nonBindSuggestEvaluateUnitTaxPrice;
                //         annualOutputData[0].investigationYearOutputTax = priceParams.nonBindSuggestInvestigationYearOutPutTax;
                //     }
                // }
                
                break;
            default:
                priceParams[key] = value;
                break;
        }
        
        this.setState({ priceParams, annualOutputData, nonBindAnnualOutputData })
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            params: {},
            customerParams: {},
            KeyAnalysisData: {},
            annualOutputData: [],
            priceParams: {},
            rate: 0,
            type: '',
            fileList: [],
            evaluateCalcGpId: null,
            universalParams: {},
        });
    }

    sumbit = () => {
        const { params, serveFeeType, annualOutputData, nonBindAnnualOutputData, priceParams, type, fileList, evaluateCalcGpId, universalParams } = this.state;
        if (type == 'floorPrice' && !evaluateCalcGpId) {
            return message.warning('请先计算 GP 测算')
        }
        // 访视制:未查询到参考单价时不允许提交建议底价
        if (type == 'floorPrice' && priceParams.basePriceStatus === 'VISIT' && universalParams.haveEmpCost === false) {
            return message.warning('请联系业务线负责人设置参考单价')
        }
        const { evaluateRecordId } = params;
        const { 
            evaluateVisitQuotationId, 
            evaluateFteQuotationId,
            evaluateTotalPrice, 
            evaluateUnitPrice, 
            investigationYearOutput, 
        } = (annualOutputData[0] || {});
        const { 
            id: nonBindEvaluateQuotationId,
            evaluateTotalPrice: nonBindEvaluateTotalPrice, 
            evaluateUnitPrice: nonBindEvaluateUnitPrice, 
            investigationYearOutput: nonBindInvestigationYearOutput, 
        } = (nonBindAnnualOutputData[0] || {});
        const {
            //建议底价数据：
            evaluateRecordBasePriceId,
            gpCalcuationValue,
            // whetherPushGpCalcuationValue,
            suggestEvaluateUnitPrice,
            suggestEvaluateTotalPrice,
            suggestInvestigationYearOutPut,
            suggestEvaluateUnitTaxPrice,
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            remark,
            nonBindSuggestEvaluateUnitPrice,
            nonBindSuggestEvaluateTotalPrice,
            nonBindSuggestInvestigationYearOutPut,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
            quotationApprovalStatus,
            businessProposalUnitPrice,
            businessProposalTotalPrice,
            businessProposalInvestigationYearOutPut,
            nonBindBusinessProposalUnitPrice,
            nonBindBusinessProposalTotalPrice,
            nonBindBusinessProposalInvestigationYearOutPut,
            businessProposalRemark,
            approvalOpinion,
            basePriceStatus,
        } = priceParams;
        if (serveFeeType == 'NON_BIND,BIND' && !suggestEvaluateUnitPrice) {
            return message.warning('请输入建议单例价格金额(不含税)/人民币')
        }
        if (serveFeeType == 'NON_BIND,BIND' && !nonBindSuggestEvaluateUnitPrice) {
            return message.warning('请输入非盲建议单例价格金额(含税)/人民币')
        }
        if (serveFeeType == 'BIND' && !suggestEvaluateUnitPrice) {
            return message.warning('请输入建议单例价格金额(不含税)/人民币')
        }
        if (serveFeeType == 'NON_BIND' && !nonBindSuggestEvaluateUnitPrice) {
            return message.warning('请输入非盲建议单例价格金额(含税)/人民币')
        }
        if (type == 'examine' && !quotationApprovalStatus) {
            return message.warning('请选择审核结论')
        }
        if (type == 'examine' && quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED' && !approvalOpinion) {
            return message.warning('请输入审批不通过原因')
        }
        this.setState({ loading: true });
        const sendParams = {
            evaluateRecordId,
            evaluateRecordBasePriceId,
            evaluateQuotationId: basePriceStatus === 'VISIT' ?  evaluateVisitQuotationId : evaluateFteQuotationId,
            nonBindEvaluateQuotationId,
            evaluateTotalPrice,
            evaluateUnitPrice,
            investigationYearOutput,
            nonBindEvaluateTotalPrice,
            nonBindEvaluateUnitPrice,
            nonBindInvestigationYearOutput,
            gpCalcuationValue,
            // whetherPushGpCalcuationValue,
            suggestEvaluateUnitPrice,
            suggestEvaluateTotalPrice,
            suggestInvestigationYearOutPut,
            suggestEvaluateUnitTaxPrice,
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            remark,
            nonBindSuggestEvaluateUnitPrice,
            nonBindSuggestEvaluateTotalPrice,
            nonBindSuggestInvestigationYearOutPut,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
            serveFeeType,
            quotationApprovalStatus: type == 'examine' ? quotationApprovalStatus : undefined,
            businessProposalUnitPrice: type == 'examine' ? businessProposalUnitPrice : undefined,
            businessProposalTotalPrice: type == 'examine' ? businessProposalTotalPrice : undefined,
            businessProposalInvestigationYearOutPut: type == 'examine' ? businessProposalInvestigationYearOutPut : undefined,
            nonBindBusinessProposalUnitPrice: type == 'examine' ? nonBindBusinessProposalUnitPrice : undefined,
            nonBindBusinessProposalTotalPrice: type == 'examine' ? nonBindBusinessProposalTotalPrice : undefined,
            nonBindBusinessProposalInvestigationYearOutPut: type == 'examine' ? nonBindBusinessProposalInvestigationYearOutPut : undefined,
            businessProposalRemark: type == 'examine' ? businessProposalRemark : undefined,
            approvalOpinion: type == 'examine' ? approvalOpinion : undefined,
            basePriceStatus: type == 'examine' ? basePriceStatus : undefined,
            evaluateCalcGpId,
            ...universalParams,
        }
        const fromData = new FormData();
        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
        fileList.map((file, index) => {
            fromData.append(`files[${index}]`, file)
        });
        
        for (const key in sendParams) {
            if (sendParams[key] || sendParams[key] == 0) {
                fromData.append(`${key}`, sendParams[key]);
            }
        }
        const url = type == 'examine' ? API_URL.evaluate.approvalClinicalQuotation : API_URL.evaluate.processBasePriceStatus;
        fetch(url, {
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            if (data.error) {
                message.error(data.error);
                this.setState({ loading: false });
            } else {
                message.success(data.success);
                this.hide();
                this.props.loadData();
                if (type == 'floorPrice') {
                    this.props.hide();
                }
            }
        }).catch(err => {
            message.error(err);
            this.setState({ loading: false });
        });
    }

    getTreatGroupColumns = () => {
        const columns = [
            {
                title: '组别',
                dataIndex: 'groupName',
                key: 'groupName',
                width: 100,
                render: (text, record) => {
                    const { rowSpan } = record;
                    return {
                        props: { rowSpan },
                        children: text,
                    }
                }
            },
            {
                title: '访视方案名称',
                dataIndex: 'visitGroupingName',
                key: 'visitGroupingName',
                width: 100,
                render: (text, record) => {
                    const { rowSpan } = record;
                    return {
                        props: { rowSpan },
                        children: text,
                    }
                }
            },
            {
                title: '随机病例数',
                dataIndex: 'randomCaseNum',
                key: 'randomCaseNum',
                width: 100,
                render: (text, record) => {
                    const { rowSpan } = record;
                    return {
                        props: { rowSpan },
                        children: text,
                    }
                }
            },
            {
                title: '药物数量',
                dataIndex: 'medicationNumberName',
                key: 'medicationNumberName',
                width: 100,
                render: (text, record) => {
                    const { rowSpan } = record;
                    return {
                        props: { rowSpan },
                        children: text,
                    }
                }
            },
            {
                title: '给药途径',
                dataIndex: 'routeName',
                key: 'routeName',
                width: 100,
            },
            {
                title: '给药类别',
                dataIndex: 'routeType',
                key: 'routeType',
                width: 100,
            },
            {
                title: '药物名称',
                dataIndex: 'drugName',
                key: 'drugName',
                width: 100,
            },
            {
                title: '来院访视周期',
                dataIndex: 'visitCycleShow',
                key: 'visitCycleShow',
                width: 100,
                className: 'header-blue',
            },
            {
                title: '来院用药频率(指的是患者来院访视用药)',
                dataIndex: 'medicationCycleShow',
                key: 'medicationCycleShow',
                width: 100,
                className: 'header-orange',
            },
            {
                title: '治疗期来院用药次数',
                dataIndex: 'medicationShow',
                key: 'medicationShow',
                width: 100,
            },
            {
                title: '静脉数',
                dataIndex: 'veinNum',
                key: 'veinNum',
                width: 100,
                render: (text, record) => {
                    const { rowSpan } = record;
                    return {
                        props: { rowSpan },
                        children: text,
                    }
                }
            },
        ];
        return columns
    }

    getAnnualOutputColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: '标准访视数',
                dataIndex: 'standardVisitAmount',
                key: 'standardVisitAmount',
                width: 100,
            },
            {
                title: '标准工时/调整FTE',
                dataIndex: 'pmEstimatedFte',
                key: 'pmEstimatedFte',
                width: 100,
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}总价金额(含税)/人民币`,
                dataIndex: 'evaluateTotalPriceTax',
                key: 'evaluateTotalPriceTax',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}总价金额(不含税)/人民币`,
                dataIndex: 'evaluateTotalPrice',
                key: 'evaluateTotalPrice',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}单例价格金额(含税)/人民币`,
                dataIndex: 'evaluateUnitPriceTax',
                key: 'evaluateUnitPriceTax',
                width: 100,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}单例价格金额(不含税)/人民币`,
                dataIndex: 'evaluateUnitPrice',
                key: 'evaluateUnitPrice',
                width: 100,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}项目年产出(含税)/人民币`,
                dataIndex: 'investigationYearOutputTax',
                key: 'investigationYearOutputTax',
                width: 100,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}项目年产出(不含税)/人民币`,
                dataIndex: 'investigationYearOutput',
                key: 'investigationYearOutput',
                width: 100,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
        ];
        return columns
    }

    getNonBindAnnualOutputColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}总价金额（含税）/人民币`,
                dataIndex: 'evaluateTotalPriceTax',
                key: 'evaluateTotalPriceTax',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}总价金额（不含税）/人民币`,
                dataIndex: 'evaluateTotalPrice',
                key: 'evaluateTotalPrice',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}单例价格金额（含税）/人民币`,
                dataIndex: 'evaluateUnitPriceTax',
                key: 'evaluateUnitPriceTax',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}单例价格金额（不含税）/人民币`,
                dataIndex: 'evaluateUnitPrice',
                key: 'evaluateUnitPrice',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}项目年产出（含税）/人民币`,
                dataIndex: 'investigationYearOutputTax',
                key: 'investigationYearOutputTax',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: `${isBindAndNonBind ? '非盲服务' : ''}项目年产出（不含税）/人民币`,
                dataIndex: 'investigationYearOutput',
                key: 'investigationYearOutput',
                width: 100,
                render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
        ];
        return columns
    }

    beforeUpload = (file) => {
        this.setState({
            fileList:[
                ...this.state.fileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({fileList: newFileList});
    }
    // 打开GP测算弹窗
    goGpCalculate = () => {
        const { priceParams: { basePriceStatus }, record: { evaluateRecordId }, parameterValue } = this.state;
        this.GPCalculateModalRef.show(evaluateRecordId, basePriceStatus, parameterValue, 'FloorPriceModal');
    }
    // GP测算提交
    gpCalcuationSubmit = (finalGp, unitPrice, nonBindUnitPrice, evaluateCalcGpId, universalParams) => {
        const { serveFeeType } = this.state;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        this.handleChange(finalGp, 'gpCalcuationValue');
        if (isBind) {
            this.handleChange(unitPrice, 'suggestEvaluateUnitPrice');
        }
        if (isNonBind) {
            this.handleChange(unitPrice, 'nonBindSuggestEvaluateUnitPrice');
        }
        if (isBindAndNonBind) {
            this.handleChange(unitPrice, 'suggestEvaluateUnitPrice');
            this.handleChange(nonBindUnitPrice, 'nonBindSuggestEvaluateUnitPrice');
        }
        this.setState({
            evaluateCalcGpId,
            universalParams,
        });
    }

    render() {
        const { visible, loading, params, KeyAnalysisData, customerParams, annualOutputData, nonBindAnnualOutputData, priceParams, rate, type, fileList, serveFeeType } = this.state;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        const { treatGroupList = [] } = customerParams;
        const { 
            evaluateCode,
            evaluateSerialNumber,
            investigationMedicine,
            diseaseName,
            investigationAreaName,
            startSiteNum,
            researchCycle,
            joinGroupPeriod,
            treatmentPeriod,
            followUpPeriod,
            survivalFollowUpPeriod,
            randomCaseNum,
            singlePatientTotalCount,
            smoPredicatedAverageInGroupRate,
            targetNames,
        } = params;
        const { 
            productQualityState,
            programmeQualityState,
            programmeInRowState,
            researchProcessCorrelation,
            contendProductExperimentState,
        }= KeyAnalysisData;
        const {
            //建议底价数据：
            gpCalcuationValue,
            // whetherPushGpCalcuationValue,
            suggestEvaluateUnitPrice,
            suggestEvaluateTotalPrice,
            suggestInvestigationYearOutPut,
            nonBindSuggestEvaluateUnitPrice,
            nonBindSuggestEvaluateTotalPrice,
            nonBindSuggestInvestigationYearOutPut,
            suggestEvaluateUnitTaxPrice,
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
            remark,
            quotationApprovalStatus,
            businessProposalUnitPrice,
            businessProposalTotalPrice,
            businessProposalInvestigationYearOutPut,
            nonBindBusinessProposalUnitPrice,
            nonBindBusinessProposalTotalPrice,
            nonBindBusinessProposalInvestigationYearOutPut,
            businessProposalRemark,
            approvalOpinion,
        } = priceParams;
        const suggestEvaluateUnitPriceValue = isBind ? 'suggestEvaluateUnitPrice' : 'nonBindSuggestEvaluateUnitPrice';
        const suggestEvaluateTotalPriceValue = isBind ? 'suggestEvaluateTotalPrice' : 'nonBindSuggestEvaluateTotalPrice';
        const suggestInvestigationYearOutPutValue = isBind ? 'suggestInvestigationYearOutPut' : 'nonBindSuggestInvestigationYearOutPut';
        const suggestEvaluateUnitTaxPriceValue = isBind ? 'suggestEvaluateUnitTaxPrice' : 'nonBindSuggestEvaluateUnitTaxPrice';
        const suggestEvaluateTotalTaxPriceValue = isBind ? 'suggestEvaluateTotalTaxPrice' : 'nonBindSuggestEvaluateTotalTaxPrice';
        const suggestInvestigationYearOutPutTaxValue = isBind ? 'suggestInvestigationYearOutPutTax' : 'nonBindSuggestInvestigationYearOutPutTax';
        const businessProposalUnitPriceValue = isBind ? 'businessProposalUnitPrice' : 'nonBindBusinessProposalUnitPrice';
        const businessProposalTotalPriceValue = isBind ? 'businessProposalTotalPrice' : 'nonBindBusinessProposalTotalPrice';
        const businessProposalInvestigationYearOutPutValue = isBind ? 'businessProposalInvestigationYearOutPut' : 'nonBindBusinessProposalInvestigationYearOutPut';
        const asterisk = <span style={{ color: 'red' }}>*</span>;

        return (
            <Modal
                title={type == 'floorPrice' ? "建议底价" : "总价审批"}
                visible={visible}
                onOk={this.sumbit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={1000}
                bodyStyle={{
                    minHeight: 750
                }}
            >
                <div className="cont-cont">
                    <ul className="preview-list">
                        <li>
                            <div >临床评估单号：{evaluateCode}</div>
                        </li>
                        <li className="title"><h4>1.方案基本信息</h4></li>
                        <li>
                            <div className="item">
                                <label className="ui-label">方案编号</label>
                                <span className="ui-text">{evaluateSerialNumber}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">试验药物（或器械/试剂）名称</label>
                                <span className="ui-text">{investigationMedicine}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">适应症</label>
                                <span className="ui-text">{diseaseName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">治疗领域</label>
                                <span className="ui-text">{investigationAreaName}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">启动中心数</label>
                                <span className="ui-text">{startSiteNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">研究周期（月）</label>
                                <span className="ui-text">{researchCycle}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">入组期（月）</label>
                                <span className="ui-text">{joinGroupPeriod}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">治疗期（月）</label>
                                <span className="ui-text">{treatmentPeriod}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">随访期（月）</label>
                                <span className="ui-text">{followUpPeriod}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">生存随访期（月）</label>
                                <span className="ui-text">{survivalFollowUpPeriod}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">随机病例数</label>
                                <span className="ui-text">{randomCaseNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">每例病人访视次数</label>
                                <span className="ui-text">{singlePatientTotalCount}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 220, marginLeft: -140 }}>此项目入组速率预估（pts/site/m）</label>
                                <span className="ui-text">{smoPredicatedAverageInGroupRate}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">靶点</label>
                                <span className="ui-text">{targetNames}</span>
                            </div>
                        </li>

                        <li className="title"><h4>2.访视方案</h4></li>
                        <li>
                            <TableC
                                data={treatGroupList}
                                loading={loading}
                                columns={this.getTreatGroupColumns()}
                                pagination={false}
                            />
                        </li>

                        <li className="title"><h4>3.重点难点分析</h4></li>
                        <li>
                            <div className="item">
                                <label className="ui-label">研发产品优劣情况</label>
                                <span className="ui-text" style={{ width: 700, whiteSpace: 'normal' }}>{productQualityState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">治疗方案优劣情况</label>
                                <span className="ui-text" style={{ width: 700, whiteSpace: 'normal' }}>{programmeQualityState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">项目方案入排相关</label>
                                <span className="ui-text" style={{ width: 700, whiteSpace: 'normal' }}>{programmeInRowState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">研究流程相关</label>
                                <span className="ui-text" style={{ width: 700, whiteSpace: 'normal' }}>{researchProcessCorrelation}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">竞争产品或竞争实验情况</label>
                                <span className="ui-text" style={{ width: 700, whiteSpace: 'normal' }}>{contendProductExperimentState}</span>
                            </div>
                        </li>
                        <li className="title"><h4>4.年产出</h4></li>
                        <li>
                            {
                                isBindAndNonBind ? <div>
                                    <div style={{ marginBottom: 10 }}>
                                    <div style={{ marginBottom: 10 }}>盲态服务年产出</div>
                                        <TableC
                                            data={annualOutputData}
                                            loading={loading}
                                            columns={this.getAnnualOutputColumns(isBindAndNonBind)}
                                            pagination={false}
                                        />
                                    </div>
                                    <div sstyle={{ marginBottom: 10 }}>
                                    <div style={{ marginBottom: 10 }}>非盲服务年产出</div>
                                        <TableC
                                            data={nonBindAnnualOutputData}
                                            loading={loading}
                                            columns={this.getNonBindAnnualOutputColumns(isBindAndNonBind)}
                                            pagination={false}
                                        />
                                    </div>
                                </div> 
                                :
                                <TableC
                                    data={isBind ? annualOutputData : nonBindAnnualOutputData}
                                    loading={loading}
                                    columns={ 
                                        isBind ? 
                                        this.getAnnualOutputColumns() 
                                        : 
                                        this.getNonBindAnnualOutputColumns()
                                    }
                                    pagination={false}
                                />
                            }
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>GP%</label>
                                <span className="ui-text">
                                    {
                                        (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') ? <span><InputNumber 
                                            placeholder='请输入'
                                            precision={2}
                                            step={0.01}
                                            style={{ width: 220, marginRight: 5 }}
                                            value={gpCalcuationValue}
                                            disabled={true}
                                            onChange={value => this.handleChange(value, 'gpCalcuationValue')}
                                        /></span> : gpCalcuationValue  
                                    }
                                    {
                                        type == 'floorPrice' && <Button type="primary" onClick={this.goGpCalculate}>GP 测算</Button>
                                    }
                                </span>
                            </div>
                        </li>
                        {/* {
                            typeof(gpCalcuationValue) === 'number' && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>{asterisk}是否推送GP测算值</label>
                                    <span className="ui-text">
                                        {
                                            (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') ? 
                                                <RadioGroup 
                                                    value={whetherPushGpCalcuationValue}
                                                    onChange={e => this.handleChange(e.target.value, 'whetherPushGpCalcuationValue')} 
                                                >
                                                    <Radio value='1' style={{ marginRight: 50 }}>是</Radio>
                                                    <Radio value='0'>否</Radio>
                                                </RadioGroup> 
                                                : (whetherPushGpCalcuationValue == '0' ? '否' : '是')
                                        }
                                    </span>
                                </div>
                            </li>
                        } */}
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>{asterisk}建议单例价格金额(不含税)/人民币</label>
                                <span className="ui-text">
                                    {
                                        (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') ? <InputNumber 
                                            precision={2}
                                            step={0.01}
                                            placeholder='请输入'
                                            style={{ width: 220 }}
                                            value={priceParams[suggestEvaluateUnitPriceValue]}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            disabled={true}
                                            onChange={value => this.handleChange(value, suggestEvaluateUnitPriceValue)}
                                        /> : format('money', priceParams[suggestEvaluateUnitPriceValue])
                                    }
                                </span>
                            </div>
                        </li>
                        }
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>建议总价金额(不含税)/人民币</label>
                                <span className="ui-text">{format('money', priceParams[suggestEvaluateTotalPriceValue])}</span>
                            </div>
                        </li>
                        }
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>建议项目年产出(不含税)/人民币</label>
                                <span className="ui-text">
                                {format('money', priceParams[suggestInvestigationYearOutPutValue])}
                                </span>
                            </div>
                        </li>
                        }

                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>{asterisk}盲态服务建议单例价格金额(不含税)/人民币</label>
                                <span className="ui-text">
                                    {
                                        (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') ? <InputNumber 
                                            precision={2}
                                            step={0.01}
                                            placeholder='请输入'
                                            style={{ width: 220 }}
                                            value={suggestEvaluateUnitPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            disabled={true}
                                            onChange={value => this.handleChange(value, 'suggestEvaluateUnitPrice')}
                                        /> : (suggestEvaluateUnitPrice ? `${suggestEvaluateUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')
                                    }
                                </span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>盲态服务建议总价金额(不含税)/人民币</label>
                                <span className="ui-text">{suggestEvaluateTotalPrice ? `${suggestEvaluateTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>盲态服务建议项目年产出(不含税)/人民币</label>
                                <span className="ui-text">{suggestInvestigationYearOutPut ? `${suggestInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>{asterisk}非盲服务建议单例价格金额(不含税)/人民币</label>
                                <span className="ui-text">
                                    {
                                        (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') ? <InputNumber
                                            precision={2}
                                            step={0.01}
                                            placeholder='请输入'
                                            style={{ width: 220 }}
                                            value={nonBindSuggestEvaluateUnitPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            disabled={true}
                                            onChange={value => this.handleChange(value, 'nonBindSuggestEvaluateUnitPrice')}
                                        /> : (nonBindSuggestEvaluateUnitPrice ? `${nonBindSuggestEvaluateUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')
                                    }
                                </span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>非盲服务建议总价金额(不含税)/人民币</label>
                                <span className="ui-text">{nonBindSuggestEvaluateTotalPrice ? `${nonBindSuggestEvaluateTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>非盲服务建议项目年产出(不含税)/人民币</label>
                                <span className="ui-text">{nonBindSuggestInvestigationYearOutPut ? `${nonBindSuggestInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }

                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>税率</label>
                                <span className="ui-text">{rate}%</span>
                            </div>
                        </li>
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>{asterisk}建议单例价格金额(含税)/人民币</label>
                                <span className="ui-text">
                                    {format('money', priceParams[suggestEvaluateUnitTaxPriceValue])}
                                </span>
                            </div>
                        </li>
                        }
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>建议总价金额(含税)/人民币</label>
                                <span className="ui-text">
                                    {format('money', priceParams[suggestEvaluateTotalTaxPriceValue])}
                                </span>
                            </div>
                        </li>
                        }
                        {(isBind || isNonBind) &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>建议项目年产出(含税)/人民币</label>
                                <span className="ui-text">
                                    {format('money', priceParams[suggestInvestigationYearOutPutTaxValue])}
                                </span>
                            </div>
                        </li>
                        }

                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>盲态服务建议单例价格金额(含税)/人民币</label>
                                <span className="ui-text">
                                    {
                                        suggestEvaluateUnitTaxPrice ? `${suggestEvaluateUnitTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                                    }
                                    
                                </span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>盲态服务建议总价金额(含税)/人民币</label>
                                <span className="ui-text">{suggestEvaluateTotalTaxPrice ? `${suggestEvaluateTotalTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>盲态服务建议项目年产出(含税)/人民币</label>
                                <span className="ui-text">{suggestInvestigationYearOutPutTax ? `${suggestInvestigationYearOutPutTax}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>非盲服务建议单例价格金额(含税)/人民币</label>
                                <span className="ui-text">
                                    {
                                        nonBindSuggestEvaluateUnitTaxPrice ? `${nonBindSuggestEvaluateUnitTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                                    }
                                    
                                </span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>非盲服务建议总价金额(含税)/人民币</label>
                                <span className="ui-text">{nonBindSuggestEvaluateTotalTaxPrice ? `${nonBindSuggestEvaluateTotalTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }
                        {isBindAndNonBind &&
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>非盲服务建议项目年产出(含税)/人民币</label>
                                <span className="ui-text">{nonBindSuggestInvestigationYearOutPutTax ? `${nonBindSuggestInvestigationYearOutPutTax}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                            </div>
                        </li>
                        }


                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>建议底价情况说明</label>
                                <span className="ui-text">
                                    {
                                        (type == 'floorPrice' || quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED')  ? <TextArea
                                            style={{ width: 220 }}
                                            rows={8}
                                            value={remark}
                                            onChange={e => this.handleChange(e.target.value, 'remark')}
                                        /> : <span style={{ whiteSpace: 'normal' }}>{remark}</span>
                                    }
                                </span>
                            </div>
                        </li>
                        {
                            (type == 'examine' && (isBind || isNonBind)) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>商务建议单例价格金额(含税)/人民币</label>
                                    <span className="ui-text">
                                        {format('money', priceParams[businessProposalUnitPriceValue])}
                                    </span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && (isBind || isNonBind)) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>商务建议总价金额(含税)/人民币</label>
                                    <span className="ui-text">
                                        {format('money', priceParams[businessProposalTotalPriceValue])}
                                    </span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && (isBind || isNonBind)) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>商务建议项目年产出(含税)/人民币</label>
                                    <span className="ui-text">
                                        {format('money', priceParams[businessProposalInvestigationYearOutPutValue])}
                                    </span>
                                </div>
                            </li>
                        }

                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>盲态商务建议单例价格金额(含税)/人民币</label>
                                    <span className="ui-text">{businessProposalUnitPrice ? `${businessProposalUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>盲态商务建议总价金额(含税)/人民币</label>
                                    <span className="ui-text">{businessProposalTotalPrice ? `${businessProposalTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>盲态商务建议项目年产出(含税)/人民币</label>
                                    <span className="ui-text">{businessProposalInvestigationYearOutPut ? `${businessProposalInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>非盲商务建议单例价格金额(含税)/人民币</label>
                                    <span className="ui-text">{nonBindBusinessProposalUnitPrice ? `${nonBindBusinessProposalUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>非盲商务建议总价金额(含税)/人民币</label>
                                    <span className="ui-text">{nonBindBusinessProposalTotalPrice ? `${nonBindBusinessProposalTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }
                        {
                            (type == 'examine' && isBindAndNonBind) && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>非盲商务建议项目年产出(含税)/人民币</label>
                                    <span className="ui-text">{nonBindBusinessProposalInvestigationYearOutPut ? `${nonBindBusinessProposalInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                                </div>
                            </li>
                        }

                        {
                            type == 'examine' && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>备注说明</label>
                                    <span className="ui-text" style={{ whiteSpace: 'normal' }}>{businessProposalRemark}</span>
                                </div>
                            </li>
                        }
                        {
                            type == 'examine' && <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: 300 }}>{asterisk}审核结论</label>
                                    <span className="ui-text">
                                        <RadioGroup 
                                            value={quotationApprovalStatus}
                                            onChange={e => this.handleChange(e.target.value, 'quotationApprovalStatus')} 
                                        >
                                            <Radio value='QUOTATION_STATUS_APPROVAL' style={{ marginRight: 50 }}>审批通过</Radio>
                                            <Radio value='QUOTATION_STATUS_REFUSED'>审批不通过</Radio>
                                        </RadioGroup>
                                    </span>
                                </div>
                            </li>
                        }
                        {
                            quotationApprovalStatus &&
                                <li>
                                    <div className="item">
                                        <label className="ui-label" style={{ width: 300 }}>{quotationApprovalStatus == 'QUOTATION_STATUS_APPROVAL' ? '' : asterisk}{quotationApprovalStatus == 'QUOTATION_STATUS_APPROVAL' ? '审批通过原因' : '审批不通过原因'}</label>
                                        <span className="ui-text">
                                            <Input
                                                placeholder='请输入'
                                                style={{ width: 220 }}
                                                value={approvalOpinion}
                                                onChange={e => this.handleChange(e.target.value, 'approvalOpinion')} 
                                            />
                                        </span>
                                    </div>
                                </li>
                        }
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{ width: 300 }}>底价测算文档</label>
                                <span className="ui-text">
                                    <Upload
                                        data={{
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        fileList={fileList}
                                        beforeUpload={this.beforeUpload}
                                        onRemove={this.handleRemove}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <GPCalculateModal
                    ref={ref => this.GPCalculateModalRef = ref}
                    gpCalcuationSubmit={this.gpCalcuationSubmit}
                />
            </Modal>
        );
    }
}

export default FloorPriceModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FloorPriceModal.js